import React, { Component } from "react";
import PropTypes from "prop-types";
import { getUniversityList, changeStatus } from "../Actions/AdminAction";
import { getInstituteList } from "../Actions/AdminAction";
import { token, roleid } from "../Actions/AuthAction";
import ReactPaginate from "react-paginate";
import { showLoader, hideLoader } from "../../utils";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import Loader from "../Common/Loader";
import CONFIG from "../../config";

export default class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      token: token(),
      data: [],
      totalCount: 0,
      showModel: false,
      limit: 5,
      currentPage: 0,
      search: "",
      status: "",
      istrending: "",
      loading: true,
      city: "",
      state: "",
    };
  }

  componentDidMount() {
    const { search, status, city, state, currentPage, limit, token } =
      this.state;
    const model = {
      key: token,
      page: currentPage + 1,
      search: search,
      status: status,
      city: city,
      state: state,
      limit: limit,
    };

    this.setState({
      currentPage: 0,
    });
    this.loadList(model);
  }

  loadList = (model) => {
    this.setState({
      loading: true,
    });
    getInstituteList(model)
      .then((res) => {
        hideLoader(this);
        this.setState({
          totaldata: res.totaldata,
          data: res.data,
          originalData: res.data,
          totalCount: res.totaldata,
          loading: false,
        });
      })
      .catch((e) => hideLoader(this));
  };

  viewDetail = (e, item) => {
    const id = item.id;

    this.props.history.push({
      pathname: `/institutionadd/${id}`,
      state: {
        detail: item,
      },
    });
  };

  handlePageClick = (data) => {
    let selected = data.selected;

    this.setState(
      {
        currentPage: selected,
      },
      () => {
        const { search, status, city, state, limit, token } = this.state;
        const model = {
          key: token,
          page: selected + 1,
          search: search,
          status: status,
          city: city,
          state: state,
          limit: limit,
        };
        this.loadList(model);
      }
    );
  };

  filterdata = (data) => {
    const { search, status, city, state, currentPage, limit, token } =
      this.state;
    const model = {
      key: token,
      page: currentPage + 1,
      search: search,
      status: data,
      city: city,
      state: state,
      limit: limit,
    };
    this.loadList(model);
  };

  searchdata = (data) => {
    const { search, status, city, state, currentPage, limit, token } =
      this.state;
    const model = {
      key: token,
      page: currentPage + 1,
      search: data,
      status: status,
      city: city,
      state: state,
      limit: limit,
    };
    this.loadList(model);
  };

  onSearchValue = (e) => {
    this.setState({
      search: e.target.value,
    });
  };

  OnCheckboxStatusChange = (e, code) => {
    Swal.fire({
      title: `Are you sure, you want to mark this institution as ${e.target.checked ? "InActive" : "Active"
        } ?`,
      text: "",
      icon: "",
      buttons: true,
      dangerMode: false,
    }).then((willDelete) => {
      if (willDelete) {
        const { data } = this.state;
        data.map((item) => {
          if (item.user.id === code) {
            item.user.status = e.target.checked;
          }
        });

        console.log(e.target.checked);
        console.log(code);
        this.setState({ data }, () => {
          changeStatus({
            loginusertoken: token(),
            userid: code,
            status: !e.target.checked,
          }).then((res) => {
            console.log("status updated");
            Swal.fire("Success", res.message, "success");
          });
        });
      }
    });
  };

  render() {
    const { data, totalCount, limit, loading } = this.state;
    return (
      <>
        {loading && <Loader />}
        <div className="row mb-4">
          <div className="col-md-12">
            <h4 className="table_heading position-relative">
              PARTNER CONSULTANT/INSTITUTION LIST
            </h4>
          </div>
        </div>
        <div className="card table_card mb-4">
          <div className="card-body">
            <div className="">
              <form className="d-flex justify-content-between form-group tableform">
                <div>
                  <select
                    onChange={(e) => this.filterdata(e.target.value)}
                    className="form-control"
                  >
                    <option value="">All</option>
                    <option value="1">Active</option>
                    <option value="0">InActive</option>
                  </select>
                </div>
                <div className="search-box mb-2">
                  <input
                    className="search-text"
                    type="text"
                    placeholder="Search"
                    value={this.state.search}
                    onChange={this.onSearchValue}
                  />
                  <button
                    type="button"
                    className="search-btn"
                    onClick={(e) => this.searchdata(this.state.search)}
                  >
                    <i className="fas fa-search"></i>
                  </button>
                </div>
              </form>
            </div>
            <div className="table-responsive">
              <table
                className="table table-bordered"
                width="100%"
                cellspacing="0"
              >
                <thead>
                  <tr>
                    <th>S.No.</th>
                    <th>Logo</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Website</th>

                    <th>Location</th>
                    <th>Affiliation</th>
                    <th>Status</th>

                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.data.length > 0
                    ? this.state.data.map((item, i) => (
                      <tr>
                        <td>
                          {this.state.currentPage * this.state.limit + ++i}
                        </td>
                        <td>
                          <img
                            src={`${CONFIG.IMAGE_URL}/${item.logo}`}
                            width="50px"
                          />
                        </td>

                        <td>{item.name}</td>

                        <td>{item.user.email}</td>
                        <td>{item.user.phone}</td>

                        <td>{item.weburl}</td>
                        <td>{item.address}</td>
                        <td>
                          {item.instutionbelongto == 1
                            ? "Affiliated to University"
                            : "Autonomous Institute"}
                        </td>
                        <td>
                          <label className="switch switchyes">
                            <input
                              type="checkbox"
                              checked={item.user.status ? 0 : 1}
                              onChange={(e) =>
                                this.OnCheckboxStatusChange(e, item.user.id)
                              }
                            />
                            <span className="slidernormal round"></span>
                          </label>
                        </td>
                        <td>
                          <span className="tabledropdown">
                            <span className="abtn">
                              <i
                                class="fa fa-ellipsis-v"
                                id="dropdownMenuLink"
                                data-toggle="dropdown"
                              ></i>
                              <div
                                class="dropdown-menu editdrp"
                                aria-labelledby="dropdownMenuLink"
                              >
                                <span
                                  onClick={(e) => this.viewDetail(e, item)}
                                  class="dropdown-item"
                                  style={{ cursor: "pointer" }}
                                >
                                  Edit
                                </span>

                                {roleid() == 1 &&
                                  item.instutionbelongto == 1 && (
                                    <Link
                                      class="dropdown-item"
                                      to={`/linkinguniversity/${item.id}`}
                                    >
                                      Link University
                                    </Link>
                                  )}
                                <Link
                                  class="dropdown-item"
                                  to={`/institutionprofile/${item.id}`}
                                >
                                  View Details
                                </Link>
                              </div>
                            </span>
                          </span>
                        </td>
                      </tr>
                    ))
                    :
                    <td colSpan={10} className="text-center">No data found</td>
                  }
                </tbody>
              </table>
            </div>
            <div className="d-flex justify-content-between">
              <h6>
                <span>{`${this.state.currentPage
                  ? this.state.currentPage * this.state.limit + 1
                  : 1
                  }-${data.length < limit
                    ? totalCount
                    : (this.state.currentPage + 1) * this.state.limit
                  }`}</span>{" "}
                <span>/ {this.state.totalCount} Search Results</span>
              </h6>
              <div class="pagination">
                <ReactPaginate
                  previousLabel={
                    <i
                      className="fa fa-angle-double-left"
                      aria-hidden="true"
                    ></i>
                  }
                  nextLabel={
                    <i
                      className="fa fa-angle-double-right"
                      aria-hidden="true"
                    ></i>
                  }
                  pageCount={
                    this.state.totalCount % this.state.limit === 0
                      ? parseInt(this.state.totalCount / this.state.limit)
                      : parseInt(this.state.totalCount / this.state.limit) + 1
                  }
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={10}
                  onPageChange={this.handlePageClick}
                  activeClassName={"active"}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
